import { Settings } from '../components/Settings/Settings'

export const SettingsPage = () => {
    return <Settings />
}
